import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const MyCarousel = ({ images }) => {
  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div style={{ height: "100%" }}>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <img
              src={image}
              alt={"news background"}
              onLoad={() => window.dispatchEvent(new Event("resize"))}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
